export class DropdownFilter {
    constructor(nominatedSpeakerList) {
        const keys = nominatedSpeakerList
            .filter(item => item.dropdown_filter === true)
            .map(item => ({ [item.columnKey]: [] }));

        this.keyToDisplayNameMap = nominatedSpeakerList
            .filter(item => item.dropdown_filter === true)
            .reduce((acc, item) => {
                acc[item.columnKey] = item.display_name;
                return acc;
            }, {});
        this.data = keys.reduce((acc, obj) => {
            const keyName = Object.keys(obj)[0];
            acc[keyName] = [];
            return acc;
        }, {});
        this.filteredRows = [];
        this.readyToBeRendered = false;
    }

    // Getters / Setters
    getData() {
        return this.data;
    }

    setReadyToBeRendered(value) {
        this.readyToBeRendered = value;
    }

    // Primary methods
    addDropdownFilterValueIfAble(key, row) {
        // Add value to this.data if key is tracked
        if (key in this.data && row[key] != null) {
            const normalizedValue = row[key].toString().trim().toLowerCase();

            if (!this.data[key].includes(normalizedValue)) {
                this.data[key].push(normalizedValue);
            }
        }
    }

    addFilteredRow(row) {
        // Require speaker_id to enforce uniqueness
        if (row.speaker_id == null) {
            return;
        }

        const filteredRow = {
            speaker_id: row.speaker_id
        };

        Object.keys(this.data).forEach(k => {
            if (row[k] != null) {
                filteredRow[k] = row[k];
            }
        });

        const exists = this.filteredRows.some(r => r.speaker_id === filteredRow.speaker_id);

        if (!exists) {
            this.filteredRows.push(filteredRow);
        }
    }

    render() {
        const container = $('#speaker_nominate_dropdown_filter_container');

        // Prevent re-render if not ready, during "drawCallback", or if there's empty data
        if (
            !this.readyToBeRendered
            || container.children().length > 0
            || !this.data
            || Object.keys(this.data).length === 0
        ) {
            return;
        }

        // Clear
        container.empty();

        // Create new dropdowns
        Object.keys(this.data).forEach(key => {
            const wrapper = $('<div class="col-3"></div>');
            const label = $(`<label class="form-label">${this.toTitleCase(this.keyToDisplayNameMap[key])}</label>`);
            const select = $(`<select class="form-select" name="${key}"></select>`);

            select.append(
                `<option value="" selected>Select ${this.toTitleCase(this.keyToDisplayNameMap[key])}</option>`
            );
            this.data[key].forEach(val => {
                select.append(`<option value="${val}">${this.toTitleCase(val)}</option>`);
            });

            wrapper.append(label);
            wrapper.append(select);
            container.append(wrapper);
        });
    }

    // Update methods
    updateDropdownOptions() {
        const container = $('#speaker_nominate_dropdown_filter_container');
        const selectedFilters = {};
        const allowedValues = {};

        // 1. Get current selected values
        container.find('select').each(function () {
            const key = $(this).attr('name');
            const val = $(this).val();

            selectedFilters[key] = val || null;
        });

        // 2. Filter rows using AND logic
        const matchingRows = this.filteredRows.filter(row => {
            return Object.keys(selectedFilters).every(key => {
                if (!selectedFilters[key]) {
                    return true;
                }

                return row[key] && row[key].toString().toLowerCase() === selectedFilters[key];
            });
        });

        // 3. Build allowed values per key
        Object.keys(this.data).forEach(key => {
            allowedValues[key] = new Set();

            matchingRows.forEach(row => {
                if (row[key] != null) {
                    allowedValues[key].add(row[key].toString().toLowerCase());
                }
            });
        });

        // 4. Update dropdowns (disable + hide invalid options)
        container.find('select').each(function () {
            const key = $(this).attr('name');

            $(this).find('option').each(function () {
                const val = $(this).val();

                if (!val) {
                    $(this).prop('disabled', false).show();
                    return;
                }

                if (allowedValues[key].has(val)) {
                    $(this).prop('disabled', false).show();
                } else {
                    $(this).prop('disabled', true).hide();
                }
            });
        });
    }

    updateGlobalSearchBar(ele) {
        const input = $('#datatable_speaker_nominate_filter input[type="search"]');
        const prevText = ele.data('prevText');
        const newText = ele.find('option:selected').text();
        const newValue = ele.val();
        let currentVal = input.val().trim();

        // Remove previous value if it exists
        if (prevText) {
            const prevValue = `"${prevText}"`;

            currentVal = currentVal
                .replace(new RegExp(`\\s?${prevValue}\\s?`, 'g'), ' ')
                .trim()
                .replace(/\s+/g, ' ');
        }

        // Add new value (only if a real value is selected)
        if (newValue) {
            const newValueFormatted = `"${newText}"`;

            currentVal = currentVal.length === 0 ? newValueFormatted : `${currentVal} ${newValueFormatted}`;
        }

        // Save current as previous for next change
        ele.data('prevText', newValue ? newText : null);

        input.val(currentVal);
        input.trigger('input');
    }

    // Reset
    resetFilters() {
        const container = $('#speaker_nominate_dropdown_filter_container');
        const input = $('#datatable_speaker_nominate_filter input[type="search"]');

        // 1. Reset dropdowns
        container.find('select').each(function () {
            this.selectedIndex = 0;

            // Clear stored previous value
            $(this).data('prevText', null);

            // Re-enable and show all options
            $(this).find('option')
                .prop('disabled', false)
                .show();
        });

        // 2. Clear search input
        input.val('');
        input.trigger('input');
    }

    // Helper methods
    toTitleCase(str) {
        return str.replace(/\w\S*/g, w =>
            w.charAt(0).toUpperCase() + w.slice(1)
        );
    }
}
